import { render, staticRenderFns } from "./InputSigarusCheckboxList.vue?vue&type=template&id=61feef85&"
import script from "./InputSigarusCheckboxList.vue?vue&type=script&lang=js&"
export * from "./InputSigarusCheckboxList.vue?vue&type=script&lang=js&"
import style0 from "./InputSigarusCheckboxList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports